import Configuracion from './Configuracion'

export default Configuracion